'use strict';

/**
 * View for group members
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var GroupMembersModalView;  //See last line -> Can only be populated after module.exports because it's a circular dependency. See http://stackoverflow.com/questions/30378226/circular-imports-with-webpack-returning-empty-object

var template = require('modules/community/templates/partials/group-members.hbs');

var GroupMembersView = ItemView.extend({
    template: template,

    tagName: 'ul',

    compactStyle: true,

    className: function(){
        var classNames = ['group-members'];

        if (this.getOption('compactStyle')) {
            classNames.push('compact')
        }

        return classNames.join(' ');
    },

    ui: {
        'showContactInfo': '[data-action="show-contact-info"]',
        'showGroupMembers': '[data-action="show-group-members"]',
        'addContact': '[data-action="add-to-contacts"]',
    },

    events: {
        'click @ui.showContactInfo': 'showContactInfo',
        'click @ui.showGroupMembers': 'showGroupMembers',
        'click @ui.addContact': 'addContact',
    },

    modelEvents: {
        'change': 'modelChanged',
    },

    groupMemberLimit: 5,

    templateHelpers: {
        t: function() {
            if (this.model.get('type') === 'broadcast') {
                var translationKey = arguments[0];
                var broadcastLabels = {
                    // 'community::group:action:rename': 'community::broadcast:action:rename',
                };

                if (_.has(broadcastLabels, translationKey)) {
                    arguments[0] = broadcastLabels[translationKey];
                }
            }

            return App.t.apply(App, arguments);
        },
    },

    showGroupMembers: function() {
        var groupMembersModal = new GroupMembersModalView({
            model: this.model,
        });

        var options = {
            additionalClassName: 'modal-center modal-restriction modal-community-group-members',
            additionalBgClassName: 'light-bg',
        };

        App.addModal(groupMembersModal, options);
    },

    showContactInfo: function(event) {
        var button = $(event.currentTarget);
        var userId = button.data('userId');

        var li = button.closest('li');

        li.addClass('show-contact-infos');

        // Close actions overlay on next click
        setTimeout(function(){
            $('body').one('click', function() {
                this.hideContactInfos(li);
            }.bind(this));
        }.bind(this), 0)
    },

    hideContactInfos: function(li) {
        li.removeClass('show-contact-infos');
    },

    addContact: function(event) {
        var button = $(event.currentTarget);
        var userId = button.data('userId');

        App.radio('community').execute('add:contacts', userId);
    },

    modelChanged: function() {
        if (this.isDestroyed) { return; }

        this.render();
    },
});

module.exports = GroupMembersView;

GroupMembersModalView = require('modules/community/views/layout/group-members-modal');